import { render } from "./BookingHistory.vue?vue&type=template&id=a0693ede"
import script from "./BookingHistory.vue?vue&type=script&lang=js"
export * from "./BookingHistory.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__